// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    0,
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "电厂动力设备及运行",
      "tec": "白羽申宇",
      "week": "1-8周",
      "add": "教学楼D座419文法"
    },
    {
      "sub": "能源电力工程概论",
      "tec": "马翔宇滕志飞",
      "week": "1-8周",
      "add": "教学楼D座419文法"
    },
    0,
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "生产运行与项目管理",
      "tec": "马彤兵",
      "week": "1-12周",
      "add": "教学楼D座419文法"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电厂动力设备及运行",
      "tec": "白羽申宇",
      "week": "1-8周",
      "add": "教学楼D座419文法"
    },
    0,
    {
      "sub": "新能源机械设备",
      "tec": "尹晓伟",
      "week": "3-13,15周",
      "add": "教学楼A座318机械"
    },
    0,
    {
      "sub": "工程伦理概论",
      "tec": "张小辉金钰",
      "week": "1-8周",
      "add": "教学楼D座419文法"
    }
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
